import { render } from "./Form.vue?vue&type=template&id=e10c59fa&ts=true"
import script from "./Form.vue?vue&type=script&lang=ts&setup=true"
export * from "./Form.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/CropManagement/Form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e10c59fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e10c59fa', __exports__)) {
    console.log('reload')
    api.reload('e10c59fa', __exports__)
  }
  
  module.hot.accept("./Form.vue?vue&type=template&id=e10c59fa&ts=true", () => {
    console.log('re-render')
    api.rerender('e10c59fa', render)
  })

}


export default __exports__